<template>
	<div class="old_top_head">
		<div class="topbox" v-if="this.$route.name!='Giftlist'&&this.$route.name!='Lottery'&&this.$route.name!='Winnerlist'&&this.$route.name!='Lotterytest'&&this.$route.name!='AvatarWall'&&this.$route.name!='SubaruAboutUs'&&this.$route.name!='CartoonIndexList'&&this.$route.name!='CartoonIndexInfo'">
			<div class="width_all">
				<div class="topnet">
					<div class="top_box">
						<div class="top_box_child">
							<div class="display_flex flex_1">
								<a href="https://m.motortime.com/" target="_blank" class="a_color">汽车时间</a>
								<div class="ml-5"> 官网 www.motortime.com</div>
							</div>
							<Poptip class="mr-20 cursor_p" v-if="this.$route.name!='CartoonIndexList'&&this.$route.name!='CartoonIndexInfo'" trigger="hover">
								小程序
								<div slot="content">
									<div class="wechat_box">
										<div class="wechat_cell">
											<img class="wechat_img" :src="img.motortime">
											<div>
												<div class="f-18">汽车时间小程序</div>
												<div class="wechat_des">属于你的汽车时间</div>
											</div>
										</div>
										<div class="wechat_cell">
											<img class="wechat_img" :src="img.lexus">
											<div>
												<div class="f-18">凌志范儿小程序</div>
												<div class="wechat_des">雷克萨斯粉丝车主服务平台</div>
											</div>
										</div>
										<div class="wechat_cell">
											<img class="wechat_img" :src="img.subaru">
											<div>
												<div class="f-18">富士范儿小程序</div>
												<div class="wechat_des">斯巴鲁粉丝车主服务平台</div>
											</div>
										</div>
										<div class="wechat_cell">
											<img class="wechat_img" :src="img.vtec">
											<div>
												<div class="f-18">VTEC范儿小程序</div>
												<div class="wechat_des">本田粉丝车主服务平台</div>
											</div>
										</div>
										<div class="wechat_cell">
											<img class="wechat_img" :src="img.shop">
											<div>
												<div class="f-18">汽车时间商城小程序</div>
												<div class="wechat_des">好看、好玩、好用</div>
											</div>
										</div>
									</div>
								</div>
							</Poptip>
							<Poptip class="mr-20 cursor_p" v-if="this.$route.name!='CartoonIndexList'&&this.$route.name!='CartoonIndexInfo'" trigger="hover">
								下载APP
								<div slot="content">
									<div class="topapp_box" :style="'background-image:url('+img.code_bk+')'">
										<div class="mb-5">扫码下载汽车时间APP</div>
										<img class="top_qrcode" :src="img.qrcode">
									</div>
								</div>
							</Poptip>
							<div class="appfont" v-if="isLogin">{{username}}
								<span class="ml-20" @click="outLogin">退出</span>
							</div>
							<div class="appfont" @click="gologin()" v-else>登录 / 注册</div>
						</div>
					</div>
				</div>
				<div class="top_cell_box">
					<div class="top_cell_width">
						<div class="display_flex">
							<a href="https://www.motortime.com/" target="_blank" @click="goLogoHome">
								<img class="oldpc_logo" :src="img.pc_logo">
							</a>
							<div class="top_cell_cell">
								<div @click="goPage(0)" :class="activePage==0?'page_name page_name_active':'page_name'">首页</div>
								<div v-for="item in list" :key="item.id" @click="goPage(item.id,item.title)":class="activePage==item.id?'page_name page_name_active':'page_name'">{{item.title}}</div>
								<div @click="goPage(999,'直播')" :class="activePage==999?'page_name page_name_active':'page_name'">直播</div>
								<!-- <div @click="goPage(9999,'行业报告')" :class="activePage==9999?'page_name page_name_active':'page_name'">行业报告</div> -->
							</div>
						</div>
					</div>
				</div>
			</div> 
			<div v-if="appcodebk" class="overlay" @click="appoverlay()"></div>
			<div v-if="loginshow" class="loginoverlay"></div>
			<div class="loginbox" v-if="loginshow">
				<div class="text-r">
					<img class="closepic" :src="img.close" @click="closelogin()">
				</div>
				<div class="login_box">
					<div class="f-w f-30">欢迎登陆</div>
					<div class="motorinput">
						<i-input placeholder="输入手机号" @on-change="changeMobile" :readonly="isgetCode">
							<span slot="prepend"><img class="mobilepic" :src="img.mobile"></span>
							<span slot="append">
								<i-button :class="isMobile?'btn-gold':'btn-gray'" shape="circle" @click="getCode()" :disabled="!isMobile">获取验证码<span v-if="isgetCode">({{second}}s)</span></i-button>
							</span>
						</i-input>
					</div>
					<div class="motorinput">
						<i-input placeholder="输入验证码" @on-change="changeCode">
							<span slot="prepend"><img class="codepic" :src="img.code"></span>
							<span slot="append"></span>
						</i-input>
					</div>
					<i-button :class="isCode?'btn-gold submitbtn':'btn-gray submitbtn'" :disabled="!isCode" shape="circle" long @click="memLogin">登录</i-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import home from '../api/motortime';
	export default {
		data (){
			return {
				list:[],
				menunum:1,
				wechatcode:false,
				ioscode:false,
				androidcode:false,
				appcodebk:false,
				loginshow:false,
				isMobile:false,
				isCode:false,
				isLogin:false,
				second:60,
				isgetCode:false,
				username:'',
				img:{
					logo: require('../assets/img/logo.png'),
					pc_logo: require('../assets/img/pc_logo.png'),
					appdownload: require('../assets/img/appdownload.png'),
					code_bk: require('../assets/img/code_bk.png'),
					android: require('../assets/img/android.png'),
					ios: require('../assets/img/ios.png'),
					wechat: require('../assets/img/wechat.png'),
					qrcode: require('../assets/img/qrcode.png'),
					close: require('../assets/img/close.png'),
					mobile: require('../assets/img/mobile.png'),
					code: require('../assets/img/code.png'),
					motortime: require('../assets/img/wechat/motortime.png'),
					lexus: require('../assets/img/wechat/lexus.png'),
					subaru: require('../assets/img/wechat/subaru.png'),
					vtec: require('../assets/img/wechat/vtec.png'),
					shop: require('../assets/img/wechat/shop.png'),
					topMobile: require('../assets/img/hoime_icon/mobile.png'),
					topWechat: require('../assets/img/hoime_icon/wechat.png'),
				}
			}
		},
		props:['activePage'],
		created () {

			if(this.list.length==0){
				this.getChannel()
			}
			if(localStorage.getItem('userinfo')){
				var userinfo=JSON.parse(localStorage.getItem('userinfo'))
				this.isLogin=true
				this.username=userinfo.username
			}
			this.getChannel()
		},
		methods:{
			getChannel(){
				home.getChannel({is_web:1}).then(res => {
					if(res.data.state == 1) {

						this.list=res.data.data
						

					}
				})
			},
			goPage(type,name){
				if(type==0){
					this.$router.push({
						name: 'Home'
					})
				}else if(type=='999'){
					this.$router.push({
						path: '/livelist/'+type
					})
				}else if(type=='9999'){
					this.$router.push({
						path: '/report/'+type
					})
				}else{
					this.$router.push({
						path: '/articlelist/'+type
					})
				}
				localStorage.setItem('activePage', type)
			},
			goLogoHome(){
				localStorage.setItem('activePage', 0)
			},
			outLogin(){
				this.isLogin=false
				localStorage.clear()
			},
			gologin(){
				if(!this.isLogin){
					this.loginshow=true
					window.scrollTo(0, 0)
				}
			},
			appoverlay(){
				this.wechatcode=false
				this.ioscode=false
				this.androidcode=false
				this.appcodebk=false
			},
			closelogin(){
				this.loginshow=false
			},
			changeMobile(event){
				var mobile=event.target.value
				if(!(/^1[3456789]\d{9}$/.test(mobile))){
					this.isMobile=false
					return false
				}else{
					this.mobile=mobile
					this.isMobile=true
				}
			},
			getCode(){
				if(this.mobile==''){
					this.$Message.error('请填写手机号');
					return false
				}else if(!(/^1[3456789]\d{9}$/.test(this.mobile))){
					this.$Message.error('请填写正确的手机号');
					return false
				}else{
					this.isgetCode=true
					let second = 60;
					const timer = setInterval(() => {
						second--;
						if (second) {
							this.second=second
						} else {
							clearInterval(timer);
							this.second=60
							this.isMobile=true
							this.isgetCode=false
						}
					}, 1000);
					var params={
						mobile:this.mobile
					}

					home.getCode(params).then(res => {
						if(res.data.state == 1) {
							this.isMobile=false
						}else{
							alert(res.data.error[0])
							clearInterval(timer);
							this.second=60
							this.isMobile=true
							this.isgetCode=false
						}
					})
				}
			},
			changeCode(){
				var code=event.target.value
				if(this.mobile==''){
					this.$Message.error('请填写手机号');
					return false
				}else if(!(/^1[3456789]\d{9}$/.test(this.mobile))){
					this.$Message.error('请填写正确的手机号');
					return false
				}else{
					this.isCode=true
					this.code=code
				}
			},
			memLogin(){
				if(this.mobile==''){
					this.$Message.error('请填写手机号');
					return false
				}else if(!(/^1[3456789]\d{9}$/.test(this.mobile))){
					this.$Message.error('请填写正确的手机号');
					return false
				}else{
					if(!(/^\d{6}$/).test(this.code)){
						this.$Message.error('请填写正确的验证码');
						this.isCode=false
						return false
					}else{
						var params={
							mobile:this.mobile,
							code:this.code,
							source:2
						}
						home.getLogin(params).then(res => {
							if(res.data.state == 1) {
								this.username=res.data.data.user.username
								this.loginshow=false
								this.mobile=false
								this.code=false
								this.isLogin=true
								localStorage.setItem('pc_token', res.data.data.access_token)
								var userinfo=JSON.stringify(res.data.data.user)
								localStorage.setItem('userinfo', userinfo)
							}else{
								alert(res.data.error[0])
							}
						})
					}
				}
			},
		}
	}
</script>
<style lang="scss">
	.old_top_head{
		.topbox{
			position: fixed!important;
			top: 0!important;
			left: 0;
			right: 0;
			display: flex;
			justify-content: center;
			width: 100%;
			height: 100px!important;
			z-index: 999;
			background-color: #fff;
			border-bottom: 1px solid #ddd;
			.width_all{
				width: 100%;
				.topnet{
					width:100%;display: flex;justify-content: center;
					background: linear-gradient(#F5F5F5, #F8F8F8);
					.top_box{
						width: 1200px;
						.top_box_child{
							display: flex;
							align-items: center;
							height: 38px;
							color: #6a6a6a;
							font-weight: 500;
							font-size: 12px;
							.appfont{
								font-size: 12px;
								cursor: pointer;
								color: #000000;font-weight: 500;
							}
						}
					}
				}
				.top_cell_box{
					width: 100%;
					display: flex;
					justify-content: center;
					.top_cell_width {
						width: 1200px;
						.oldpc_logo{
							height: 62px;
							width: 135px;
							margin-left: 1px;
							cursor: pointer;
						}
						.top_cell_cell{
							flex:1;
							margin-left: 40px;
							display: flex;
							align-items: center;
							height: 62px;
							.page_name{
								color: #515a6e;
								padding:0 20px;
								font-size: 16px;
								cursor:pointer;
							}
							.page_name_active{
								background-color:#F5BC41;
								padding:2px 10px;
								border-radius:3px;
							}
						}

					}

				}
			}
		}
	}
	
</style>


// WEBPACK FOOTER //
// src/components/oldTopHead.vue